import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import IllegalArgumentException from '../../../../java/lang/IllegalArgumentException';
var Location = /*#__PURE__*/function () {
  function Location() {
    _classCallCheck(this, Location);
  }
  _createClass(Location, null, [{
    key: "toLocationSymbol",
    value: function toLocationSymbol(locationValue) {
      switch (locationValue) {
        case Location.EXTERIOR:
          return 'e';
        case Location.BOUNDARY:
          return 'b';
        case Location.INTERIOR:
          return 'i';
        case Location.NONE:
          return '-';
      }
      throw new IllegalArgumentException('Unknown location value: ' + locationValue);
    }
  }]);
  return Location;
}();
export { Location as default };
Location.INTERIOR = 0;
Location.BOUNDARY = 1;
Location.EXTERIOR = 2;
Location.NONE = -1;